import { FieldRendererProps } from "../fieldRenderersEditors";
import StringFieldRenderer from "./StringFieldRenderer";

export class NumberFieldRenderer extends StringFieldRenderer<FieldRendererProps> {

}

export default NumberFieldRenderer;